import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'

function Header() {
	const navigate = useNavigate()
	const [teamUser, setTeamUser] = useState(null)

	useEffect(() => {
		const storedTeamUser = localStorage.getItem('teamUser')

		if (storedTeamUser && storedTeamUser !== 'null') {
			try {
				setTeamUser(JSON.parse(storedTeamUser))
			} catch (error) {
				console.error('Invalid teamUser data')
			}
		}
	}, [])

	function handleLogout() {
		localStorage.clear()
		navigate('/')
	}

	const displayName =
		teamUser?.name || [teamUser?.firstName, teamUser?.lastName].filter(Boolean).join(' ')

	return (
		<header className="topnavbar-wrapper">
			<nav className="navbar topnavbar">
				<a className="navbar-brand" href="#/" />

				<div className="brand-logo" style={{ marginLeft: '3.25rem' }}>
					<img
						className="img-fluid"
						src="/img/logo1.png"
						alt="App Logo"
						style={{ width: '60px', height: '40px' }}
					/>
				</div>

				<ul className="navbar-nav mr-auto flex-row" style={{ marginLeft: '3.25rem' }}>
					<li className="nav-item">
						<a
							className="nav-link d-none d-md-block d-lg-block d-xl-block p-0"
							href="#"
							data-toggle-state="aside-collapsed"
						>
							<em className="fas fa-bars"></em>
						</a>
					</li>
				</ul>

				{teamUser && (
					<ul className="navbar-nav flex-row align-items-center mr-3">
						<li className="nav-item text-right text-white">
							<div style={{ lineHeight: '1.2' }}>
								<strong style={{ fontSize: '16px' }}>{displayName}</strong>
								<div style={{ fontSize: '16px' }}>{teamUser?.email}</div>
								<div style={{ fontSize: '16px' }}>{teamUser?.mobile}</div>
							</div>
						</li>
					</ul>
				)}

				<ul className="navbar-nav flex-row">
					<li className="nav-item">
						<span className="nav-link" onClick={handleLogout} style={{ cursor: 'pointer' }}>
							Log Out
						</span>
					</li>
				</ul>
			</nav>
		</header>
	)
}

export default Header
